import { render, staticRenderFns } from "./editLogisticsModal.vue?vue&type=template&id=15938e28&scoped=true"
import script from "./editLogisticsModal.vue?vue&type=script&lang=js"
export * from "./editLogisticsModal.vue?vue&type=script&lang=js"
import style0 from "./editLogisticsModal.vue?vue&type=style&index=0&id=15938e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15938e28",
  null
  
)

export default component.exports